// SPDX-License-Identifier: GPL-3.0-or-later

import { SCREEN_JSON_SCHEMA } from '../schemas';

export interface ScreenPromptInputs {
  preferences: string;
  jobTitle: string;
  companyName: string;
  jobUrl: string;
  applyType: string;
  jobDescription: string;
}

export const screenSystemPrompt = `You decide whether a job posting matches a user's stated preferences.

You output ONLY valid JSON matching exactly this TypeScript shape:

${SCREEN_JSON_SCHEMA}

Rules:
- No markdown, no code fences, no commentary — only the JSON.
- Be strict about hard dealbreakers the user listed (location, seniority, IC vs management, industry exclusions).
- Be lenient about soft preferences when the job is otherwise a strong fit.
- If the description is too thin to evaluate confidently, default to match = true and say so in the reason.
- "reason" must be one or two sentences and cite the specific signals you used.
- "signals" (optional) is a short bullet list of pros and cons.`;

export function screenUserPrompt(inputs: ScreenPromptInputs): string {
  return `<preferences>
${inputs.preferences.trim()}
</preferences>

<job>
Title: ${inputs.jobTitle}
Company: ${inputs.companyName}
Apply type: ${inputs.applyType}
URL: ${inputs.jobUrl}

${inputs.jobDescription.trim() || '(no description recorded)'}
</job>

Output the JSON.`;
}
